import { styled, css } from '@mui/material'
import AppBody from '../AppBody'
import AppHeader from '../AppHeader'
import ModalBox from '../ModalBox'

export const DialogWrapper = styled(ModalBox)(() => css``)
DialogWrapper.defaultProps = {
  fullScreen: false,
  padding: 16
}

export const DialogHeader = styled(AppHeader)(() => css``)
DialogHeader.defaultProps = {
  elevation: 0
}

export const DialogBody = styled(AppBody)(
  ({ theme }) => css`
    background-color: ${theme.palette.background.paper};

    .AppHeader + & {
      margin-top: -24px;
      padding-top: 0;
      padding-bottom: 32px;
    }
  `
)
